import { render, staticRenderFns } from "./qualifications.vue?vue&type=template&id=2dae3f15&scoped=true&"
import script from "./qualifications.vue?vue&type=script&lang=js&"
export * from "./qualifications.vue?vue&type=script&lang=js&"
import style0 from "./qualifications.vue?vue&type=style&index=0&id=2dae3f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae3f15",
  null
  
)

export default component.exports